import { z } from 'zod';
import id from './uuid.dto';

const association = z.object({
  id,
  createdAt: z.date(),
  updatedAt: z.date().optional(),
});

export default association;
